import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function ChangeTaxSuccess(props: any) {
    const { reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.ChangeTaxStatus.Success.back}
                backLink="nct"
                info1={dashboard.ChangeTaxStatus.Success.subHeadingInfo1}
                infospan2={`${reqId}`}
                info3={dashboard.ChangeTaxStatus.Success.subHeadingInfo3}
                list={[]}
                handleClick={() => props.history.push('/portal/track')}
            />
        </div>
    );
}
